import type { ThemeState } from '@atlaskit/tokens/theme-config';
import { themeStringToObject } from '@atlaskit/tokens/theme-string-to-object';

type FinalTheme = Partial<ThemeState> | ThemeState | null;

export const getThemeFromQueryParams = ({ themeState }: { themeState?: string }): FinalTheme =>
	themeState ? themeStringToObject(decodeURIComponent(themeState)) : null;
